import { Button } from "react-bootstrap";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";

const buttonActionStyle = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

export const initListAgentFilterInput = {
  search: "",
  page: 1,
  pageSize: 10,
  startDate: null,
  endDate: null,
};

export const initDisburseCommissionFilterInput = {
  search: "",
  page: 1,
  pageSize: 10,
  startDate: null,
  endDate: null,
  status: "",
};

export const initDetailCommissionFilterInput = {
  page: 1,
  pageSize: 10,
};

export const renderListAgentColumns = (handleDisbursementButton) => {
  return [
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
      width: "13%",
    },
    {
      dataIndex: "npwp",
      key: "npwp",
      title: "No. NPWP",
      width: "10%",
    },
    {
      dataIndex: "commissionTotal",
      key: "commissionTotal",
      title: "Total Komisi",
    },
    {
      dataIndex: "notYetDisbursed",
      key: "notYetDisbursed",
      title: "Belum Dicairkan",
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      title: "Nama Rekening",
    },
    {
      dataIndex: "bankNameAndNumber",
      key: "bankNameAndNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "8%",
      render: (_, record) => (
        <CanAccess
          role={AuthorizationList.create_customer_commission}
          yes={
            <div style={buttonActionStyle}>
              {record.notYetDisbursedNumber > 0 ? (
                <>
                  <Button
                    variant="primary"
                    className="btn-action btn-detail"
                    onClick={() => handleDisbursementButton(record, "process")}
                  >
                    Proses
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-action"
                    onClick={() => handleDisbursementButton(record, "reject")}
                  >
                    Batalkan
                  </Button>
                </>
              ) : null}
            </div>
          }
        />
      ),
    },
  ];
};

export const renderDetailCommissionColumn = () => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      width: "13%",
    },
    {
      dataIndex: "sbg",
      key: "sbg",
      title: "No. Surat Bukti Gadai",
      width: "10%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "loanAmount",
      key: "loanAmount",
      title: "Jumlah Pinjaman",
    },
    {
      dataIndex: "totalInterest",
      key: "totalInterest",
      title: "Total Bunga",
    },
    {
      dataIndex: "commission",
      key: "commission",
      title: "Komisi (%)",
    },
    {
      dataIndex: "commissionValue",
      key: "commissionValue",
      title: "Nilai Komisi",
    },
  ];
};

export const renderDisburseColumn = (
  isHistory = false,
  handleDetailAgentButton,
  handleDisbursementButton
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      width: "13%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "commissionTotal",
      key: "commissionTotal",
      title: "Total Komisi",
    },
    {
      dataIndex: "taxAmount",
      key: "taxAmount",
      title: "Pajak",
    },
    {
      dataIndex: "feeAdmin",
      key: "feeAdmin",
      title: "Fee Admin",
    },
    {
      dataIndex: "commissionDisbursed",
      key: "commissionDisbursed",
      title: "Total Komisi Dicairkan",
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      title: "Nama Rekening",
    },
    {
      dataIndex: "bankNameAndNumber",
      key: "bankNameAndNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "bankNameAndNumber",
      key: "bankNameAndNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "8%",
      render: (_, record) => (
        <div style={buttonActionStyle}>
          {!isHistory && (
            <CanAccess
              role={AuthorizationList.create_customer_commission}
              yes={
                <div style={buttonActionStyle}>
                  <Button
                    variant="primary"
                    className="btn-action btn-detail"
                    onClick={() => handleDisbursementButton(record)}
                  >
                    Cairkan
                  </Button>
                </div>
              }
            />
          )}
          <Button
            className="btn-action px-3"
            style={{
              padding: 5,
              backgroundColor: "#fff",
              color: "#2C465C",
              borderColor: "#2C465C",
            }}
            danger
            onClick={() => handleDetailAgentButton(record)}
          >
            Detail
          </Button>
        </div>
      ),
    },
  ];
};

export const renderHistoryDisburseColumn = (
  isHistory = false,
  handleDetailAgentButton,
  handleDisbursementButton
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      width: "13%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "commissionTotal",
      key: "commissionTotal",
      title: "Total Komisi",
    },
    {
      dataIndex: "taxAmount",
      key: "taxAmount",
      title: "Pajak",
    },
    {
      dataIndex: "feeAdmin",
      key: "feeAdmin",
      title: "Fee Admin",
    },
    {
      dataIndex: "commissionDisbursed",
      key: "commissionDisbursed",
      title: "Total Komisi Dicairkan",
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      title: "Nama Rekening",
    },
    {
      dataIndex: "bankNameAndNumber",
      key: "bankNameAndNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "bankNameAndNumber",
      key: "bankNameAndNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "transferProof",
      key: "transferProof",
      title: "Bukti Transfer",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "8%",
      render: (_, record) => (
        <div style={buttonActionStyle}>
          {!isHistory && (
            <CanAccess
              role={AuthorizationList.create_customer_commission}
              yes={
                <div style={buttonActionStyle}>
                  <Button
                    variant="primary"
                    className="btn-action btn-detail"
                    onClick={() => handleDisbursementButton(record)}
                  >
                    Cairkan
                  </Button>
                </div>
              }
            />
          )}
          <Button
            className="btn-action px-3"
            style={{
              padding: 5,
              backgroundColor: "#fff",
              color: "#2C465C",
              borderColor: "#2C465C",
            }}
            danger
            onClick={() => handleDetailAgentButton(record)}
          >
            Detail
          </Button>
        </div>
      ),
    },
  ];
};

export const renderDisburseCommissionColumn = (
  onCheck,
  onCheckAll,
  isAllChecked
) => {
  return [
    {
      dataIndex: "checkbox",
      key: "checkbox",
      title: (
        <input
          style={{ accentColor: "#fa6629", width: 15, height: 15 }}
          type="checkbox"
          id={`label-check-all`}
          checked={isAllChecked}
          onClick={(event) => onCheckAll()}
        />
      ),
      render: (_, record) => (
        <input
          style={{ accentColor: "#fa6629", width: 15, height: 15 }}
          type="checkbox"
          id={`label-check-${record.id}`}
          checked={record.is_checked}
          onClick={(event) => onCheck(record)}
        />
      ),
    },
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      width: "13%",
    },
    {
      dataIndex: "sbg",
      key: "sbg",
      title: "No. Surat Bukti Gadai",
      width: "10%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "loanAmount",
      key: "loanAmount",
      title: "Jumlah Pinjaman",
    },
    {
      dataIndex: "totalInterest",
      key: "totalInterest",
      title: "Total Bunga",
    },
    {
      dataIndex: "commission",
      key: "commission",
      title: "Komisi (%)",
    },
    {
      dataIndex: "commissionValue",
      key: "commissionValue",
      title: "Nilai Komisi",
    },
  ];
};
